import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56b8fc8f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container px-0 py-9"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Overførsel af beregning", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Angiv fra CVR/CPR eller beregningsnavn/virksomhedsnavn/email. Er CVR/CPR angivet ignores det andet søgefelt. '%' tegn kan angives som wildcard i start og/eller slut af 2. fra input felt", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Bemærk at hvis en beregning har fremskrivninger flyttes disse også", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Fra og til", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "Fra og til", -1))
const _hoisted_7 = { class: "row" }
const _hoisted_8 = {
  class: "col-md-3",
  id: "choose-forecastname-div"
}
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "input-choose-transferfrom"
}, " Fra (CVR/CPR): ", -1))
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "input-choose-transfersearch"
}, " Fra (beregn.navn/virk.navn/email): ", -1))
const _hoisted_13 = { class: "col-md-3" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "input-choose-transferto"
}, " Til virksomhed (CVR): ", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 form-button" }, [
  /*#__PURE__*/_createElementVNode("button", {
    id: "submit-button-forecast",
    type: "submit",
    class: "button button-primary adjust-button-size"
  }, " Find ")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Beregninger", -1))
const _hoisted_18 = { class: "table--responsive-scroll" }
const _hoisted_19 = {
  class: "table table--selectable",
  id: "selectable-table1"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("caption", null, "Beregninger", -1))
const _hoisted_21 = ["aria-controls"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "selectable-table1-check-all" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Vælg alle rækker")
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Beregningsnavn", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Firmanavn", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "CVR/Pogoident", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Startdato", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Slutdato", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Oprettet", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Status", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Basis for fremskrivninger", -1))
const _hoisted_31 = ["id", "value"]
const _hoisted_32 = ["for"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Vælg række", -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "Start overførsel", -1))
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { class: "col-md-5 form-button" }
const _hoisted_38 = ["disabled"]
const _hoisted_39 = {
  key: 0,
  class: "spinner-overlay"
}
const _hoisted_40 = {
  "aria-hidden": "false",
  class: "fds-modal"
}
const _hoisted_41 = { class: "modal-content" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "modal-title" }, " Bekræft overførsel ")
], -1))
const _hoisted_43 = { class: "modal-body" }
const _hoisted_44 = {
  class: "row",
  "data-cy": "load-forecast-wrapper-div"
}
const _hoisted_45 = {
  class: "col-md-4",
  id: "choose-forecastname-div"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Fra:", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_49 = { class: "col-md-4" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Beregninger:", -1))
const _hoisted_51 = {
  style: {"margin-top":"0"},
  class: "calc-summary"
}
const _hoisted_52 = { class: "col-md-4" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Til:", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_56 = { class: "modal-footer" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "modal-backdrop",
  class: "modal-backdrop"
}, null, -1))
const _hoisted_58 = {
  key: 1,
  class: "container px-0 py-9"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.pageAccess)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("form", {
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.getCompanies()), ["prevent"]))
        }, [
          _createElementVNode("fieldset", null, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-input",
                    id: "input-choose-transferfrom",
                    type: "number",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.transferFromVat) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.transferFromVat]
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-input",
                    id: "input-choose-transfersearch",
                    type: "string",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.transferFromSearch) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.transferFromSearch]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-input",
                    id: "input-choose-transferto",
                    type: "number",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.transferToVat) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.transferToVat]
                  ])
                ])
              ]),
              _hoisted_16
            ])
          ])
        ], 32),
        _createElementVNode("section", null, [
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("table", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, [
                    _createElementVNode("input", {
                      id: "selectable-table1-check-all",
                      type: "checkbox",
                      class: "form-checkbox",
                      "aria-controls": _ctx.getAriaControls
                    }, null, 8, _hoisted_21),
                    _hoisted_22
                  ]),
                  _hoisted_23,
                  _hoisted_24,
                  _hoisted_25,
                  _hoisted_26,
                  _hoisted_27,
                  _hoisted_28,
                  _hoisted_29,
                  _hoisted_30
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userCalculations, (calculation) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: calculation.id
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("input", {
                        id: 'input_' + calculation.id,
                        type: "checkbox",
                        name: "selectable-table1-check[]",
                        class: "form-checkbox",
                        value: 'input_' + calculation.id,
                        onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.getSelectedCalculations && _ctx.getSelectedCalculations(...args)))
                      }, null, 40, _hoisted_31),
                      _createElementVNode("label", {
                        for: 'input_' + calculation.id
                      }, _hoisted_34, 8, _hoisted_32)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(calculation.calculationPurpose.name), 1),
                    _createElementVNode("td", null, _toDisplayString(calculation.companyInformation.companyName), 1),
                    _createElementVNode("td", null, _toDisplayString(calculation.vatNo), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(calculation.calculationPurpose.startDate)), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(new Date(calculation.calculationPurpose.startDate).getFullYear() + calculation.calculationPurpose.endDate)), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(calculation.createdTime)), 1),
                    _createElementVNode("td", null, _toDisplayString(calculation.state.toString()), 1),
                    _createElementVNode("td", null, _toDisplayString(calculation.isBasisForForecast ? 'Ja' : 'Nej'), 1)
                  ]))
                }), 128))
              ])
            ])
          ])
        ]),
        _createElementVNode("form", {
          onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.initTransfer()), ["prevent"]))
        }, [
          _createElementVNode("fieldset", null, [
            _hoisted_35,
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("button", {
                  id: "submit-button-transfer",
                  type: "submit",
                  class: "button button-primary adjust-button-size",
                  disabled: _ctx.isDisabledButton()
                }, " Påbegynd overførsel ", 8, _hoisted_38)
              ])
            ])
          ])
        ], 32),
        (_ctx.showConfirm)
          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _hoisted_42,
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("div", _hoisted_45, [
                        _hoisted_46,
                        _hoisted_47,
                        _createTextVNode(" " + _toDisplayString(_ctx.transferFromCompany.vatNo), 1),
                        _hoisted_48,
                        _createTextVNode(" " + _toDisplayString(_ctx.transferFromCompany.name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_49, [
                        _hoisted_50,
                        _createElementVNode("ul", _hoisted_51, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.calculationsToTransfer, (calculation) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: calculation.id
                            }, _toDisplayString(calculation.calculationPurpose?.name), 1))
                          }), 128))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_52, [
                        _hoisted_53,
                        _hoisted_54,
                        _createTextVNode(" " + _toDisplayString(_ctx.transferToCompany.vatNo), 1),
                        _hoisted_55,
                        _createTextVNode(" " + _toDisplayString(_ctx.transferToCompany.name), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("button", {
                      class: "button button-primary",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.doTransfer()))
                    }, " Bekræft og overfør "),
                    _createElementVNode("button", {
                      class: "button button-primary",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.doCancel()))
                    }, " Afbryd ")
                  ])
                ])
              ]),
              _hoisted_57
            ]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_58, "Din brugerprofil har ikke adgang til dette skærmbillede"))
}